<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler
        class="d-lg-none"
        display="md"
        mobile
      />
      <SidebarToggler
        class="d-md-down-none"
        display="lg"
      />
      <b-link
        class="navbar-brand"
        to="#"
      >
        <img
          class="navbar-brand-full"
          src="../../public/img/brand/imseologo.png"
          width="140"
          height="40"
          alt="CoreUI Logo"
          @click="$router.push('/dashboard')"
        >
        <img
          class="navbar-brand-minimized"
          src="../../public/img/brand/imseo_logo.svg"
          width="30"
          height="30"
          alt="CoreUI Logo"
          @click="$router.push('/dashboard')"
        >
      </b-link>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :nav-items="nav" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view :key="$route.fullPath" />
        </div>
      </main>
      <!--aside-->
      <!--AppAside fixed>
        <DefaultAside />
      </AppAside-->
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a
          target="_blank"
          href="http://rutc24.kr"
        >Immanuel Seoul Church</a>
        <span class="ml-1">&copy; 2018-</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.itemList(),
      storeWatch: null,
      storeWatchLong: null,
      storeWatchSubmitted: null
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  mounted () {
    this.storeWatch = this.$store.watch((state) => state.AUTH, (newValue, oldValue) => {
      this.nav = nav.itemList()
    })
    this.storeWatchLong = this.$store.watch((state) => state.LONGTERM, (newValue, oldValue) => {
      this.nav = nav.itemList()
    })
    this.storeWatchSubmit = this.$store.watch((state) => state.SUBMITTED, (newValue, oldValue) => {
      this.nav = nav.itemList()
    })
  },
  beforeDistroy () {
    if (this.storeWatch) {
      this.storeWatch()
    }
    if (this.storeWatchLong) {
      this.storeWatchLong()
    }
    if (this.storeWatchSubmit) {
      this.storeWatchSubmit()
    }
  }
}
</script>
